import { render, staticRenderFns } from "./DetailGene.vue?vue&type=template&id=53c5cfbb"
import script from "./DetailGene.vue?vue&type=script&lang=js"
export * from "./DetailGene.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports